import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Material-UI
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Avatar, Typography, Grid } from '@material-ui/core'
// Icon Drawer
import BerandaIcon from '@material-ui/icons/HomeRounded';
import ProfileIcon from '@material-ui/icons/AccountBoxRounded';
import UbahPasswordIcon from '@material-ui/icons/VpnKeyRounded';
import KehadiranIcon from '@material-ui/icons/AssignmentRounded';
import MateriDiklatIcon from '@material-ui/icons/MenuBookRounded';
import SoalLatihanIcon from '@material-ui/icons/CreateRounded';
import NilaiIcon from '@material-ui/icons/EmojiEventsRounded';
import StatusPembayaranIcon from '@material-ui/icons/MonetizationOnRounded';
import StatusKelulusanIcon from '@material-ui/icons/AssignmentTurnedInRounded';
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles((theme) => ({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  menu: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    margin: theme.spacing(2),
  },
  link: {
    textDecoration:"none",
    color:"black"
  }
}));

const DrawerUser = () => {
  const classes = useStyles();
  const [state, setState] = useState({left: false});

  const toggleDrawer = (left, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [left]: open });
  };

  const list = (left) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: left === 'top' || left === 'bottom',
      })}
      role="presentation"
      // onClick={toggleDrawer(left, false)}
      onKeyDown={toggleDrawer(left, false)}
    >
      <Grid container alignItems="center">
        <Grid item>
          <Avatar className={classes.avatar}>
            {"R"}
          </Avatar>
        </Grid>
        <Grid item>
          <Typography variant="body2">
            {"RIZA ARDIANSYAH"}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
        <List>
          <Link to="/user/beranda" className={classes.link}>
            <ListItem button key={"Beranda"}>
              <ListItemIcon><BerandaIcon/></ListItemIcon>
              <ListItemText primary={"Beranda"}/>
            </ListItem>
          </Link>
          <Link to="/user/profil" className={classes.link}>
            <ListItem button key={"Profil Peserta"}>
                <ListItemIcon><ProfileIcon/></ListItemIcon>
                <ListItemText primary={"Profil Peserta"}/>
            </ListItem>
          </Link>
          <Link to="/user/password" className={classes.link}>
            <ListItem button key={"Ubah Password"}>
                <ListItemIcon><UbahPasswordIcon/></ListItemIcon>
                <ListItemText primary={"Ubah Password"}/>
            </ListItem>
          </Link>
          <Link to="/user/kehadiran" className={classes.link}>
            <ListItem button key={"Kehadiran Pelatihan"}>
              <ListItemIcon><KehadiranIcon/></ListItemIcon>
              <ListItemText primary={"Kehadiran Pelatihan"}/>
            </ListItem>
          </Link>
          <Link to="/user/materi-diklat" className={classes.link}>
            <ListItem button key={"Materi Pelatihan"}>
              <ListItemIcon><MateriDiklatIcon/></ListItemIcon>
              <ListItemText primary={"Materi Pelatihan"}/>
            </ListItem>
          </Link>
          <Link to="/user/soal" className={classes.link}>
            <ListItem button key={"Tes Pelatihan"}>
              <ListItemIcon><SoalLatihanIcon/></ListItemIcon>
              <ListItemText primary={"Tes Pelatihan"}/>
            </ListItem>
          </Link>
          <Link to="/user/nilai" className={classes.link}>
            <ListItem button key={"Nilai Pelatihan"}>
              <ListItemIcon><NilaiIcon/></ListItemIcon>
              <ListItemText primary={"Nilai Pelatihan"}/>
            </ListItem>
          </Link>
          <Link to="/user/status-pembayaran" className={classes.link}>
            <ListItem button key={"Status Pembayaran"}>
              <ListItemIcon><StatusPembayaranIcon/></ListItemIcon>
              <ListItemText primary={"Status Pembayaran"}/>
            </ListItem>
          </Link>
          <Link to="/user/status-kelulusan" className={classes.link}>
            <ListItem button key={"Status Kelulusan"}>
              <ListItemIcon><StatusKelulusanIcon/></ListItemIcon>
              <ListItemText primary={"Status Kelulusan"}/>
            </ListItem>
          </Link>
        </List>
    </div>
  );

  return (
    <div>
      {['left'].map((left) => (
        <React.Fragment key={left}>
          <IconButton className={classes.menu} onClick={toggleDrawer(left, true)} color="secondary" edge="start">
            <MenuIcon/>
          </IconButton>
          <Drawer left={left} open={state[left]} onClose={toggleDrawer(left, false)}>
            {list(left)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}

export default DrawerUser
